<div class="gift-game-overlay" [class.gift-game-fade-out]="closing" [class.host-hidden]="hostHidden"
  *ngIf="previewProducts.length >= 6 && show">
  <div class="gift-game-modal" [class.gift-game-win-mode]="rewardProduct">

    <button class="gift-game-close" (click)="close()" [disabled]="spinning" *ngIf="!spinning">
      ✕
    </button>

    <div class="gift-game-timer">
      {{
      rewardProduct
      ? (isAr ? 'مبروك! كسبت الهدية دي 🎉' : 'Congratulations! You won this gift 🎉')
      : spinning
      ? (isAr ? 'جاري تحديد هديتك...' : 'Checking your prize...')
      : (isAr ? 'اضغط على الهدية قبل ما تهرب' : 'Tap the gift before it escapes')
      }}
    </div>

    <div class="gift-game-body">

      <div class="gift-game-stage" *ngIf="!rewardProduct">
        <button type="button" class="gift-game-flying-btn" [disabled]="spinning" (click)="tapFlyingGift()"
          [style.left.%]="flyingX" [style.top.%]="flyingY"
          [style.transform]="'translate(-50%, -50%) scale(' + flyingScale + ') rotate(' + flyingRotate + 'deg)'">

          <img [src]="flyingGiftIcon" class="gift-game-img" alt="gift">
        </button>

        <div class="gift-game-stage-text">
          {{
          spinning
          ? (isAr ? 'تم الإمساك بالهدية...' : 'Gift caught...')
          : (isAr ? 'اضغط بسرعة' : 'Tap quickly')
          }}
        </div>
      </div>

      <p class="gift-game-result" *ngIf="resultText">
        {{ resultText }}
      </p>

      <div class="gift-game-possible-title" *ngIf="!rewardProduct">
        {{ isAr ? 'ممكن تكسب واحدة من الهدايا دي' : 'Possible Gifts You Can Win' }}
      </div>

      <div class="gift-game-products" [class.only-winner]="rewardProduct">
        <ng-container *ngFor="let product of previewProducts">
          <div class="gift-game-product-card" *ngIf="!rewardProduct || rewardProduct?.id === product.id"
            [class.gift-game-winner]="rewardProduct?.id === product.id">

            <div class="gift-game-product-img-wrap">
              <img [src]="transformImageUrl(product.image)">
            </div>

            <h3 class="gift-game-product-name">
              {{ getProductName(product) }}
            </h3>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</div>